import { openBlock as m, createElementBlock as e, createElementVNode as v } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(t, h) {
  return m(), e("svg", l, [...h[0] || (h[0] = [
    v("mask", {
      id: "a",
      fill: "#fff"
    }, [
      v("path", { d: "m19 19.854-7.379-4.004H9.667v4.149h-4v-4.15H3V8.004h8.623L19 4z" })
    ], -1),
    v("path", {
      fill: "currentColor",
      d: "m19 19.854-.477.879 1.477.8v-1.68zm-7.379-4.004.477-.88-.223-.12h-.254zm-1.954 0v-1h-1v1zm0 4.149v1h1v-1zm-4 0h-1v1h1zm0-4.15h1v-1h-1zM3 15.85H2v1h1zm0-7.846v-1H2v1zm8.623 0v1h.254l.223-.121zM19 4h1V2.32l-1.477.801zm0 15.854.477-.88-7.379-4.003-.477.879-.477.879 7.38 4.004zm-7.379-4.004v-1H9.667v2h1.954zm-1.954 0h-1v4.149h2v-4.15zm0 4.149v-1h-4v2h4zm-4 0h1v-4.15h-2V20zm0-4.15v-1H3v2h2.667zM3 15.85h1V8.004H2v7.847zm0-7.846v1h8.623v-2H3zm8.623 0 .477.879 7.377-4.003L19 4l-.477-.879-7.377 4.003zM19 4h-1v15.854h2V4z",
      mask: "url(#a)"
    }, null, -1),
    v("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      d: "M20.5 7.563v9.5"
    }, null, -1)
  ])]);
}
const o = { render: r };
export {
  o as default,
  r as render
};
